module.exports = __webpack_public_path__ + "img/turbo_off.b3a6d4f3.svg";